import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';

@Injectable({
	providedIn: 'root'
})
export class GoogleMapsService {

	constructor(
		private http: HttpClient,
		private config: AppConfig
	) { }

	getMapsPlaceDetail(placeID, sessionId) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/maps/placedetail?placeid=` + placeID + "&sessionid=" + sessionId);
	}

	// getMapsReverseGeocoding(lat, lng){
	// 	return this.http.get<any>(`${this.config.getConfig("apiEndpoint")}/maps/geocode?lat=` + lat + "&lng=" + lng);
	// }
}
